import { useState, useMemo } from 'react';
import type { Product } from '@/types/product';
import productData from '@/data/products.json';

export function useProducts() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const products: Product[] = productData.products;
  const categories = productData.categories;

  const filteredProducts = useMemo(() => {
    let result = products;

    if (selectedCategory !== 'all') {
      result = result.filter((p) => p.category === selectedCategory);
    }

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      result = result.filter(
        (p) =>
          p.name.toLowerCase().includes(query) ||
          p.nameHi.includes(searchQuery) ||
          p.description.toLowerCase().includes(query) ||
          p.tags.some((tag) => tag.toLowerCase().includes(query))
      );
    }

    return result;
  }, [products, searchQuery, selectedCategory]);

  const featuredProducts = useMemo(
    () => products.filter((p) => p.featured),
    [products]
  );

  return {
    products: filteredProducts,
    featuredProducts,
    categories,
    searchQuery,
    setSearchQuery,
    selectedCategory,
    setSelectedCategory,
  };
}
